/**
 * Read-only JSON block with a caption — the display counterpart to JsonField.
 *
 * Pulled out because the run-detail drawer was repeating the same captioned
 * <pre> for resolved parameters and for output, and any screen showing a stored
 * payload wants exactly this: monospaced, horizontally scrollable so a long line
 * never widens its container, and silent when there is nothing to show.
 */
export function JsonView({ label, value, className }: {
  label: string;
  value: unknown;
  className?: string;
}) {
  // an absent payload is normal (a failed run has no output), so render nothing
  // rather than a heading over an empty box
  if (value === null || value === undefined) return null;
  if (typeof value === 'object' && !Object.keys(value as object).length) return null;

  return (
    <div className={className}>
      <div className="mb-1 text-[11px] font-semibold uppercase text-gray-500">{label}</div>
      <pre className="overflow-x-auto rounded bg-gray-900 p-2 font-mono text-[11px] text-emerald-300">
        {JSON.stringify(value, null, 2)}
      </pre>
    </div>
  );
}

export default JsonView;
